<div class="row pb-3 pt-4">
  <div *ngIf="!order.history?.length " class="col alert-warning m-3 p-3 rounded">
    {{ 'HISTORY.NO_HISTORY' | translate }}
  </div>
  <div class="col-md-10" *ngIf="order.history && order.history.length">
    <div class="timeline" *ngFor="let h of order.history, let i = index; last as last" [ngClass]="{'line': !last || order.history.length === 1}">
      <div class="entry">
        <div class="title">
          <div class="date"
               *ngIf="h.eventTime && (h.eventTime | dateFormat: true : 'HH:mm') | async as date"
               [ngStyle]="{'margin-left': date.length < 16 ? '13px' : ''}">
            <app-date-with-popover
              [date]="h.eventTime">
            </app-date-with-popover>
          </div>
          <div class="icon-wrapper">
            <div class="outer-circle" *ngIf="!h.airlineNotification || h.airlineNotification?.seen">
              <div class="inner-circle"></div>
            </div>
            <i class="material-symbols-outlined exclamation-icon problem cursor-default" *ngIf="h.airlineNotification && !h.airlineNotification?.seen">
              exclamation
            </i>
          </div>
        </div>
        <div class="info" [style.margin]="last ? '0px' : '0 0 2em'">
          <div class="item">
            <span class="title">{{ 'HISTORY.ACTION' | translate }}</span>
            <span>{{h.airlineNotification ? 'Airline Notification' : h.eventID}}</span>
          </div>

          <div class="item" *ngIf="h.agent">
            <span class="title">{{ 'HISTORY.USER' | translate }}</span>
            <span>{{ h.agent }}</span>
          </div>

          <div class="item" *ngIf="h.status">
            <span class="title">{{ 'HISTORY.STATUS' | translate }}</span>
            <span>{{ h.status }}</span>
          </div>

          <div class="item" *ngIf="h.flights?.length && allowedActionsForItineraryDisplay.includes(h.eventID)">
            <span class="title"></span>
            <div class="d-flex flex-column gap-5">
              <div *ngFor="let flight of h.flights">
                <div *ngFor="let segment of flight.segments">
                  <div class="d-flex flex-wrap gap-7">
                    <div class="d-flex gap-3" style="min-width: 80px;">
                      <span [appTooltip]="{airportCode: segment.originDestination.departure?.airportCode, terminalName: segment.originDestination.departure?.terminalName}">
                        {{segment.originDestination.departure.airportCode}}
                      </span>
                      <span>→</span>
                      <span [appTooltip]="{airportCode: segment.originDestination.arrival?.airportCode, terminalName: segment.originDestination.arrival?.terminalName}">
                        {{segment.originDestination.arrival.airportCode}}
                      </span>
                    </div>

                    <span>
                      {{(segment.originDestination.departure.date | dateFormat) | async}} {{segment.originDestination.departure.time}} - {{(segment.originDestination.arrival.date | dateFormat) | async}} {{segment.originDestination.arrival.time}}
                    </span>

                    <span *ngIf="segment.flightNumber">
                      {{segment.flightNumber}}
                    </span>

                    <span *ngIf="segment.detail.classOfService?.code" class="mw-10">
                      {{segment.detail.classOfService.code}}
                    </span>

                    <span *ngIf="segment.detail.classOfService?.fare?.marketingName">
                      {{segment.detail.classOfService.fare.marketingName}}
                    </span>

                    <span *ngIf="segment.equipment?.aircraftCode">
                      {{segment.equipment.aircraftCode}}
                    </span>

                    <span *ngIf="segment.detail?.segmentType">
                      {{segment.detail.segmentType}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="item" *ngIf="h.eventID === 'OrderCanceled' && h.transactionType">
            <span class="title">{{ 'HISTORY.TYPE' | translate }}</span>
            <span>{{h.transactionType}}</span>
          </div>

          <ng-container *ngIf="h.eventID == 'OrderDisrupted'">
            <div class="item">
              <span class="title">{{ 'HISTORY.TYPE' | translate }}</span>
              <span>{{ h.details && h.details.code ? h.details.code : 'ScheduledTimeChange' }}</span>
            </div>
          </ng-container>

          <div class="item" *ngIf="['OrderTicketed', 'OrderCanceled'].indexOf(h.eventID) !== -1 && h.price">
            <span class="title">{{ 'HISTORY.PRICE' | translate }}</span>
            <span>{{ h.price?.consumer?.total }} {{ h.price?.consumer?.currency }}</span>
          </div>

          <ng-container *ngIf="h.details && h.details.type">
            <div class="item" *ngIf="h.details.type !== h.eventID">
              <span class="title">{{ 'HISTORY.TYPE' | translate }}</span>
              <span>{{ h.details.type }}</span>
            </div>

            <div class="item">
              <span class="title">{{ 'HISTORY.PRICE' | translate }}</span>
              <span>{{ h.details.totalAmount }} {{ h.details.totalAmountCurrency }}</span>
            </div>

            <div class="item" *ngIf="['SeatsAddition', 'SeatsRemoval'].indexOf(h.details.type) !== -1">
              <span class="title">{{ 'HISTORY.ITEMS' | translate }}</span>
              <span>
                <ul *ngFor="let item of h.details.items;">
                  <li>
                    <span class="midnight-color"><b>{{ 'HISTORY.SEAT' | translate }}</b></span>
                    {{item.seats[0]}} for {{item.segmentRef}}
                    <br>
                    <span class="midnight-color"><b>{{ 'HISTORY.PASSENGERS' | translate }}</b></span>
                     <ng-container *ngFor="let passenger of item.passengers; last as last">
                      {{passenger}}{{!last ? ', ' : ''}}
                    </ng-container>
                  </li>
                </ul>
              </span>
            </div>

            <div class="item" *ngIf="h.details.changedRouteDetails">
              <span class="title">{{ 'HISTORY.CHANGED' | translate }}</span>
              <span>
                <ul>
                  <li *ngFor="let route of h.details.changedRouteDetails;">
                    <span class="midnight-color"><b>{{ 'HISTORY.ITINERARY' | translate }} </b></span> {{ route.departure.airportCode + ' → ' + route.arrival.airportCode }}
                    <br>
                    <span class="midnight-color"><b>{{ 'HISTORY.DEPARTURE_DATE' | translate }} </b></span> {{(route.departure.date | dateFormat) | async}},
                    <span class="midnight-color"><b>{{ 'HISTORY.TIME' | translate }} </b></span> {{route.departure.time}}
                    <br>
                    <span class="midnight-color"><b>{{ 'HISTORY.ARRIVAL_DATE' | translate }} </b></span> {{(route.arrival.date | dateFormat) | async}},
                    <span class="midnight-color"><b>{{ 'HISTORY.TIME' | translate }} </b></span> {{route.arrival.time}}
                  </li>
                </ul>
              </span>
            </div>

            <ng-container *ngIf="h.details.type == 'DatesChange'">
              <div class="item">
                <span class="title">{{ 'HISTORY.TYPE' | translate }}</span>
                <span>{{ h.details.type }}</span>
              </div>

              <div class="item">
                <span class="title">{{ 'HISTORY.NEW' | translate }}</span>
                <span>
                  <ul>
                    <li *ngFor="let route of h.details.changedRouteDetails;">
                      <span class="midnight-color"><b>{{ route.departure.airportCode }} → {{ route.arrival.airportCode}}</b></span>
                      - {{(route.departure.date | dateFormat) | async}} {{route.departure.time}}
                    </li>
                  </ul>
                </span>
              </div>
            </ng-container>

            <div class="item" *ngIf="['SeatsAddition', 'SeatsRemoval', 'ItineraryChange'].indexOf(h.details.type) === -1">
              <span class="title">{{ 'HISTORY.ITEMS' | translate }}</span>
              <div>
                <ul *ngFor="let item of h.details.items;">
                  <li>
                    <span class="midnight-color"><b>{{ 'HISTORY.NAME' | translate }}</b></span> {{ item.name }}
                    <br>
                    <span class="midnight-color"><b>{{ 'HISTORY.PASSENGERS' | translate }}</b></span>
                    <ng-container *ngFor="let passenger of item.passengers; last as last">
                      {{passenger}}{{!last ? ', ' : ''}}
                    </ng-container>
                    <br>
                    <span class="midnight-color"><b>{{ 'HISTORY.DETAILS' | translate }} </b></span>
                    <span class="d-inline-flex flex-column">
                      <span *ngFor="let description of item.descriptions">
                        <ng-container *ngIf="h.eventID === 'OrderSplit'">
                          {{getDescriptionDetails(description).order}}:
                          <a class="red-color" (click)="openInNewTab(getDescriptionDetails(description).link)">{{getDescriptionDetails(description).id}}</a>
                        </ng-container>
                        <ng-container *ngIf="h.eventID !== 'OrderSplit'">
                          {{description}}
                        </ng-container>
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="h.details && h.details.flightDetailsDiff?.length">
            <ng-container *ngFor="let diff of h.details.flightDetailsDiff; let idx = index">
              <div class="item">
                <span class="title">
                  <ng-container *ngIf="!h.details.flightDetailsDiff[idx-1] || h.details.flightDetailsDiff[idx]?.type !== h.details.flightDetailsDiff[idx-1]?.type ">
                    {{diff.type | capitalizeFirstLetter}}
                  </ng-container>
                </span>
                <div class="d-flex flex-column gap-5">
                  <app-flight-details-diff-item
                    *ngIf="diff.old"
                    [flight]="diff.old"
                    [diffs]="diff.diffs"
                    type="old"
                    [diffType]="diff.type">
                  </app-flight-details-diff-item>

                  <app-flight-details-diff-item
                    *ngIf="diff.new"
                    [flight]="diff.new"
                    [diffs]="diff.diffs"
                    type="new"
                    [diffType]="diff.type">
                  </app-flight-details-diff-item>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <div class="item" *ngIf="h.tickets && h.tickets.length">
            <span class="title">{{ 'HISTORY.TICKETS' | translate }}</span>
            <span>
              <ul *ngFor="let ticket of h.tickets">
                <li>
                  <span class="midnight-color">
                    <b>{{ticket.ticketNumber | getTicketNumber}}</b>
                  </span> - {{ ticket.typeCodeDefinition }} for {{ ticket.passengerDetails }}
                </li>
              </ul>
            </span>
          </div>

          <div class="item" *ngIf="h.tickets && hasExchangedTickets(h.tickets)">
            <span class="title">{{ 'HISTORY.EXCHANGED_FROM' | translate }}</span>
            <span>
              <ng-container *ngFor="let ticket of h.tickets">
                <ul *ngIf="ticket.ticketExchangedNumber">
                  <li>
                    <span class="midnight-color">
                      <b>{{ticket.ticketExchangedNumber | getTicketNumber}}</b>
                    </span> - {{ ticket.typeCodeDefinition }} for {{ getPassengersNameByRef(ticket.passengerRef) | joinArrayPipe }}
                  </li>
                </ul>
              </ng-container>
            </span>
          </div>

          <ng-container *ngIf="h.airlineNotification">
            <ng-container *ngFor="let amendment of h.airlineNotification.amendments">
              <div class="item">
                <span class="title">{{ 'HISTORY.TYPE' | translate }}</span>
                <span>{{amendment.type}}</span>
              </div>
              <div class="item" *ngIf="amendment.context || amendment.contextMeaning">
                <span class="title">{{ 'HISTORY.CONTEXT' | translate }}</span>
                <span>
                  <ng-container *ngIf="amendment.contextMeaning">
                    {{amendment.contextMeaning}}
                  </ng-container>
                  <ng-container *ngIf="!amendment.contextMeaning">
                    {{amendment.context | getDisruptionDescription}}
                  </ng-container>
                </span>
              </div>
              <div class="item" *ngIf="amendment.remarks?.length">
                <span class="title">{{ 'HISTORY.REMARKS' | translate }}</span>
                <span>
                   <ul *ngFor="let remark of amendment.remarks">
                    <li>
                      {{remark}}
                    </li>
                   </ul>
                </span>
              </div>
              <div class="item" *ngIf="h.airlineNotification.seen">
                <span class="title">{{ 'HISTORY.SEEN_BY' | translate }}</span>
                <span>{{h.airlineNotification.seenBy}}</span>
              </div>
            </ng-container>
            <div class="mt-3">
              <app-notification-seen-checkbox
                [checked]="h.airlineNotification.seen"
                (emitNotificationChange)="onNotificationChange(h.airlineNotification)">
              </app-notification-seen-checkbox>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
  </div>

  <div class="col-md-2" *ngIf="order.history?.length > 1">
    <button class="btn sort-btn" (click)="toggleSort()">
      {{ 'HISTORY.DATE' | translate }}
      <i class="material-symbols-outlined" [@rotate]="isDefaultSort">
        arrow_upward
      </i>
    </button>
  </div>
</div>

<ng-template #helpPopover>
  <div class="d-flex gap-3">
    <span>Mark as seen to hide warning and</span>
    <i class="material-symbols-outlined exclamation-icon problem">
      exclamation
    </i>
    <span>for this notification</span>
  </div>
</ng-template>
